var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"barChart",staticClass:"echarts-bar",style:({height: _vm.height})},[_c('sl-chart',{attrs:{"options":_vm.barOption,"autoresize":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }